module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAAAXNSR0IB2cksfwAAADZQTFRFAAAASkpKS0tLS0tLSkpKTExMS0tLS0tLS0tLSEhIS0tLUFBQS0tLTU1NS0tLTExMSkpKS0tL5zN25gAAABJ0Uk5TADDf72BA/8/QIOAQ8FCggJBwQpOOsgAAAGVJREFUeJxNzgsOgCAMA9AiWhCQz/0v6wAnNFnCW0ZSYMUc9sR1cMTBWNLCT9LfQgaQcRxHJ0xGvMgH6vHthDorpwcLvJs2TGSe7z7Vt87fgazY3MoNdfr69A5SD4VbimxrUgXhC76EBA+kVegDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/images/edit_default.png
// module id = 104
// module chunks = 0